import { createAction } from "@reduxjs/toolkit";
import { ANALYTICS_LOAD_MORE, ANALYTICS_LOAD_PREVIOUS } from "../constants";
import { mapProduct } from "../../search/domains/results/products/mapAndInsertProducts/mapProduct";

const payloadCreator = ({ response: { products = [] }, page }) => ({
  returnedProductList: products.map((product) => mapProduct({ product })),
  page,
});

const unaryCreateAction = (type) =>
  createAction(type, (args) => ({ payload: payloadCreator(args) }));

const [analyticsLoadMore, analyticsLoadPrevious] = [
  ANALYTICS_LOAD_MORE,
  ANALYTICS_LOAD_PREVIOUS,
].map(unaryCreateAction);

export { analyticsLoadMore, analyticsLoadPrevious };
